//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import instance from '../assets/js/instance'
import { Toast } from 'vant'


export default {
  name: 'contact-us',
  data () {
    return {
      baseUrl: process.env.BASE_URL,
      name: '',
      address: '',
      message: ''
    }
  },
  computed: {
    options () {
      return this.$t('contact')
    },
    path () {
      return this.$store.getters.getPath
    }
  },
  components: {
  },
  methods: {
    submit () {
      if (this.name === '') {
        Toast(this.options.name.placeholder)
        return false
      }

      if (this.address === '') {
        Toast(this.options.phone.placeholder)
        return false
      }

       if (this.message === '') {
        Toast(this.options.message.placeholder)
        return false
      }
      this.showToast(this.options.msg.loading)
      const obj = {
        id: this.id,
        name: this.name,
        phone: this.address,
        content: this.message
      }
      instance.post('/api/message/addMessage', obj).then(res => {
        let data = res.data
        if (data.code === 0) {
          this.showToast(this.options.msg.success)
          this.name = ''
          this.address = ''
          this.message = ''
          this.$emit('close')
        } else {
          Toast(data.msg)
        }
        
        setTimeout(() => {
          this.clearToast()
        }, 500)
      }).catch(e => {
        console.log(e)
        this.clearToast()
        Toast(this.options.msg.error)
      })
  },


    showToast (data) {
      Toast.loading({
        duration: 0,
        mask: true,
        message: data || this.options.loading
      })
    },

    clearToast () {
      Toast.clear()
    },

    close () {
      this.$emit('close')
    }

  },
  mounted () {
    let id = ''
    if (this.$route.query.id) {
      id = this.$route.query.id
    }
    this.id = id
  },
  destroyed () {
  }
}
